import { render, staticRenderFns } from "./PrizesHero.vue?vue&type=template&id=71a46564&scoped=true&"
import script from "./PrizesHero.vue?vue&type=script&lang=js&"
export * from "./PrizesHero.vue?vue&type=script&lang=js&"
import style0 from "./PrizesHero.vue?vue&type=style&index=0&id=71a46564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a46564",
  null
  
)

export default component.exports